import { api } from "assets/scripts/utilities/api-clients";

export const autoGenerate = async (creditNote) => {
  const response = await api.put(
    "/account/creditnotes/auto-generate",
    creditNote,
  );

  return response;
};

export const cancel = async (params) => {
  const { creditNote, removeFiles, path = "kam" } = params;

  const endpoints = {
    kam: {
      creditNote: {
        cancel: "/kam/creditnotes/cancel",
      },
    },
    account: {
      creditNote: {
        cancel: "/account/creditnotes/cancel",
      },
    },
  };
  const response = await api.put(endpoints[path].creditNote.cancel, {
    _id: creditNote._id,
    reason: creditNote.reason,
    isFilesToBeRemoved: removeFiles,
  });

  return response;
};

export const get = async (id, source) => {
  const url = {
    kam: `/kam/creditnotes/${id}`,
    sales: `/sales/credit-note/${id}`,
    purchases: `/purchase/credit-note/${id}`,
  };
  const response = await api.get(url[source]);

  return response;
};
export const index = async (options = {}) => {
  const { source = "kam", ...rest } = options;
  const url = {
    sales: "/sales/credit-notes",
    kam: "/kam/creditnotes",
    purchases: "/purchase/credit-notes",
  };
  const response = await api.get(url[source], rest);

  return response;
};

export const post = async (creditNote) => {
  const response = await api.post("/kam/creditnotes", creditNote);

  return response;
};

export const put = async (
  creditNote,
  options = {
    params: {
      showMessage: false,
    },
  },
) => {
  const response = await api.put("/account/creditnotes", creditNote, options);

  return response;
};

export const checkNumber = async (number) => {
  const response = await api.put("/account/creditnotes/number", number);

  return response;
};
